import * as React from "react"
import { Box } from "@mui/material"

import { DateRangeBlock } from "@components"
import { DATE_PERIODS } from "@constants"
import { catalogueDetailsEvolutionDateRange } from "./Ranges"
import { catalogueDetailsCurrentPeriod } from "../@signals"


export default function CatalogueDetailsPriceEvolutionChartToolbar({handleClick, dateRange, onChange}) {
    return <Box display="flex" gap={2} alignItems="center">
        <DateRangeBlock 
            currentPeriodLabel={catalogueDetailsCurrentPeriod.value}
            maxDays={30}
            value={dateRange}
            ranges={catalogueDetailsEvolutionDateRange}
            onChange={onChange}
            onOk={() => catalogueDetailsCurrentPeriod.value = DATE_PERIODS.CUSTOM}
        />
    </Box>
}